import JCloudregionList from './JCloudregionList'

/* istanbul ignore next */
JCloudregionList.install = function (Vue) {
  Vue.component(JCloudregionList.name, JCloudregionList)
}

export default JCloudregionList
